import { render } from "./DepositionsTable.vue?vue&type=template&id=ed09801a"
import script from "./DepositionsTable.vue?vue&type=script&lang=js"
export * from "./DepositionsTable.vue?vue&type=script&lang=js"

import "./DepositionsTable.vue?vue&type=style&index=0&id=ed09801a&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__